import { useClientPortalAPI } from "@certn/api";
import { components } from "@certn/api/generated-schemas/client-portal";

interface TemplateArguments {
  template_id: string;
}

export function useCredentialVerificationTemplatesInPackages() {
  const { data: packagesData } = useClientPortalAPI(
    `/api/internal/client-portal/packages/`
  );

  const results: readonly components["schemas"]["PackageList"][] =
    packagesData?.results || [];

  const activePackages = results.filter(({ is_active }) => is_active);

  const flatActivePackageChecks = activePackages
    .map(({ packagecheck_set }) => packagecheck_set)
    .flat();

  const activateCredentialPackageChecks = flatActivePackageChecks.filter(
    ({ check_type }) => check_type === "CREDENTIAL_VERIFICATIONS_1"
  );

  const templateIdsBelongingToActivePackages: string[] = Array.from(
    new Set(
      activateCredentialPackageChecks
        ?.map((packageCheck) => {
          const templateArguments = packageCheck.arguments as TemplateArguments;
          return templateArguments?.template_id || null;
        })
        .filter((id): id is string => id !== null)
    )
  );

  return templateIdsBelongingToActivePackages;
}

export function useGetCredentialVerificationTemplates() {
  const { data } = useClientPortalAPI(
    `/api/internal/client-portal/check-arguments-templates/credential-verification/`
  );
  const results: components["schemas"]["CredentialVerificationTemplateList"][] =
    data?.results || [];

  const activeTemplateIds = results
    .filter((template) => template.id && template.is_active)
    .map((template) => template.id);

  const deactivatedTemplateIds = results
    .filter((template) => template.id && !template.is_active)
    .map((template) => template.id);

  return { activeTemplateIds, deactivatedTemplateIds };
}
